
import { Vue, Component } from 'vue-property-decorator';
import { getDetail } from '../api';
import { VueCropper } from 'vue-cropper';

@Component({
  components: {
    VueCropper,
  },
})
export default class Detail extends Vue {
  option = {
    img:
      'https://image2.cqcb.com/d/file/topics/activity/2022-02-25/-1645780391515',
    enlarge: 1,
  };
  previews: any = {};
  previewStyle = {};
  base64 = '';
  enlarge = 1;
  getCropData() {
    (this.$refs.cropper as any).getCropData((data: any) => {
      // 输出 base64
      // console.log(data);
      this.base64 = data;
    });
  }
  // 预览图片
  realTime(data: any) {
    this.previews = data;
    this.option.enlarge = 200 / this.previews.w;
    this.previewStyle = {
      width: this.previews.w + 'px',
      height: this.previews.h + 'px',
      overflow: 'hidden',
      margin: '0',
      // 固定宽度200 截图框若小了则放大内容 大了则缩小内容
      zoom: 200 / this.previews.w,
    };
  }
}
